var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component_data.component)?_c(_vm.component_data.component,_vm._g({tag:"component",attrs:{"component_data":_vm.component_data}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }